var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page__content"},[_c('div',{staticClass:"page__content__tools"},[_vm._t("tools")],2),_c('div',{staticClass:"page__content__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }